import { Dispatch, ReactNode, ComponentType, useMemo } from 'react';
import { safeMemo } from '../../../../../util/safeMemo';
import { Atom } from '../../../../icons/outlined/Atom';
import { HealthCross } from '../../../../icons/outlined/HealthCross';
import { Person } from '../../../../icons/outlined/Person';
import { Practice } from '../../../../icons/outlined/Practice';
import { SearchThink } from '../../../../icons/outlined/SearchThink';
import { SuggestionTabLabel } from '../../SuggestionTabLabel';
import { ButtonBarView, ButtonBarWrapper, TabIcon } from './ButtonBar.styles';
import { ButtonBarItem } from './ButtonBarItem';

export interface ButtonBarItemSpec {
  label: ReactNode;
  value: SuggestionTabLabel;
}

interface Props {
  items: readonly ButtonBarItemSpec[];
  value: SuggestionTabLabel;
  onChange?: Dispatch<SuggestionTabLabel>;
}

const mapLabelToIcon: Record<SuggestionTabLabel, ComponentType> = {
  All: SearchThink,
  Specialties: HealthCross,
  Practices: Practice,
  Practitioners: Person,
  Topics: Atom,
};

export const ButtonBar = safeMemo(({ items, value, onChange }: Props) => (
  <ButtonBarWrapper>
    <ButtonBarView>
      {items.map(it => {
        const Icon = useMemo(() => mapLabelToIcon[it.value], [it.value]);
        return (
          <ButtonBarItem
            key={it.value}
            selected={it.value === value}
            onSelect={onChange}
            value={it.value}
          >
            <TabIcon>
              <Icon />
            </TabIcon>
            {it.label}
          </ButtonBarItem>
        );
      })}
    </ButtonBarView>
  </ButtonBarWrapper>
));
